import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';

export default function DigitalClock() {
  const [time, setTime] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  return (
    <Typography
      variant="h4"
      sx={{
        color: 'white',
        fontWeight: 'bold',
        letterSpacing: 4,
      }}
    >
      {formatTime(time)}
    </Typography>
  );
}
